import React from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const planId = searchParams.get('plan_id');
  const billingTerm = searchParams.get('billing_term');

  function returnToCheckout() {
    if (planId && billingTerm) {
      navigate(`/checkout?plan_id=${encodeURIComponent(planId)}&billing_term=${encodeURIComponent(billingTerm)}`);
      return;
    }
    navigate('/checkout');
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-red-50 px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="text-red-500 text-5xl mb-4">❌</div>
        <h1 className="text-2xl font-bold mb-2">Payment not completed</h1>
        <p className="text-gray-700 mb-6">
          You have not been charged. Choose a payment method to try again.
        </p>
        {orderId ? (
          <p className="text-xs text-gray-500 mb-4">Reference: {orderId}</p>
        ) : null}
        <div className="flex flex-wrap gap-3 justify-center">
          <button
            className="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition"
            onClick={returnToCheckout}
          >
            Return to checkout
          </button>
          <Link
            to="/account"
            className="px-6 py-3 border border-gray-300 rounded-lg font-semibold hover:bg-gray-50 transition inline-block"
          >
            Go to account
          </Link>
        </div>
      </div>
    </div>
  );
}
